import { useCallback, useEffect, useState } from "react";
import { GetAppVersion } from "../utils/apiCalls/appVersion";
import { APP_PLATFORM } from "../utils/appPlatform";

// Shared by the App Versions page and the Admin Dashboard widget so both
// read the same "latest version per platform" data the same way.
const useLatestAppVersions = () => {
  const [latestVersions, setLatestVersions] = useState({
    [APP_PLATFORM.ANDROID]: null,
    [APP_PLATFORM.IOS]: null,
  });
  const [isLoading, setIsLoading] = useState(true);

  const fetchLatestVersions = useCallback(async () => {
    setIsLoading(true);
    const platforms = [APP_PLATFORM.ANDROID, APP_PLATFORM.IOS];
    const results = await Promise.all(
      platforms.map(async (platform) => {
        try {
          const res = await GetAppVersion(platform);
          return [platform, res?.statusCode === 200 ? res.data : null];
        } catch {
          return [platform, null];
        }
      }),
    );
    setLatestVersions(Object.fromEntries(results));
    setIsLoading(false);
  }, []);

  useEffect(() => {
    fetchLatestVersions();
  }, [fetchLatestVersions]);

  return { latestVersions, isLoading, refetchLatestVersions: fetchLatestVersions };
};

export default useLatestAppVersions;
